import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import {
    DatiqSelectComponent,
    DatiqSelectValidatorsService,
} from './components/datiq-select';
import { MatRadioModule } from '@angular/material/radio';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { DatiqIconsModule } from '@dat/datiq-components-pkg/icons';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    DatiqInputErrorTypes,
    DatiqValidatorsRegisterService,
} from '@dat/datiq-components-pkg/utils';

const components = [DatiqSelectComponent];

@NgModule({ declarations: [...components],
    exports: [...components], imports: [CommonModule,
        MatSelectModule,
        MatRadioModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        DatiqIconsModule,
        MatIconModule,
        MatChipsModule,
        MatRadioModule,
        MatCheckboxModule,
        MatInputModule,
        MatTooltipModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class DatiqSelectModule {
    constructor(
        private _validatorRegistry: DatiqValidatorsRegisterService,
        private _select: DatiqSelectValidatorsService
    ) {
        this._validatorRegistry.register(
            DatiqInputErrorTypes.SelectMatchesOptions,
            this._select
        );
    }
}
